import packageJson from '@packageJson';

/**
 * `process.env.APP_VERSION` vem do `next.config.js`, a partir do input do CI. O
 * fallback existe para nunca ficar vazia: versão vazia significa evento sem
 * `version` e sourcemap que não resolve.
 */
export const APP_VERSION: string =
  process.env.APP_VERSION ?? packageJson.version;
